import { SpellCheckImageError } from "@redotech/redo-model/spell-check-image-error";
import * as z from "zod";

export const spellCheckImage = {
  name: "spellCheckImage" as const,
  input: z.object({ imageUrl: z.string() }),
  output: z.array(SpellCheckImageError),
};
